import { WidgetId } from '@brandclub/types';
import * as index from '../BrandclubLanding/index.js';

// this is also used to order the sections in add section view
var buildWidgetIdToComponentMapping = function () {
    var widgetIdToComponentMapping = {};
    var widgetNames = Object.keys(WidgetId);
    var widgetIds = Object.values(WidgetId);
    widgetIds.forEach(function (widgetId, index$1) {
        widgetIdToComponentMapping[widgetId] = index[widgetNames[index$1]];
    });
    return widgetIdToComponentMapping;
};
var WidgetIdToComponentMapping = buildWidgetIdToComponentMapping();

export { WidgetIdToComponentMapping };
//# sourceMappingURL=WidgetMapping.js.map
